export const BookingCommentType = Object.freeze({
  /**
   * Private comments - Shouldn't be shown to candidates (ShortTerm.ClientNotes)
   */
  PRIVATE: 'Private',
  /**
   * Candidate comments - Public comments that can be shown to candidates (ShortTerm.Notes)
   */
  CANDIDATE: 'Candidate',
  /**
   * Contact comments - Contains the room number when submitted by template is required by location (ShortTerm.ContactNotes)
   */
  CONTACT: 'Contact',
  /**
   * Indicates that the candidate is late. Will contain a json object with lateMins to indicate how many minutes late the candidate is.
   */
  LATE: 'LATE',
})
